module.exports = __webpack_public_path__ + "img/tab-customers-inactive.3b463e28.svg";